'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';

angular.module('app.services')

.factory('DateRangeService', ['$q', '$rootScope', '$http', function($q, $rs, $http) {
    var service = {};

    //start and end dates used by controllers to fetch data
    service.startDate = null;
    service.endDate = null;
    service.enabled = false;

    //drs mode
    service.mode = null;

    service.format = function(date) {
        return moment.unix(date).format('YYYY-MM-DD').toString();
    };

    service.setDateDisplay = function() {
        $('.io-date-range-picker input').val(
            service.startDate + ' - ' + service.endDate
        );
    };

    //run once on header load to initialize the start and end dates
    service.setDefaultDates = function() {
        service.startDate = moment().subtract(29, 'days').format('YYYY-MM-DD').toString();
        service.endDate = moment().format('YYYY-MM-DD').toString();
    };

    //init method for setting the mode of the date range picker
    //extend new modes here
    service.init = function(mode) {
        service.mode = mode;
        var modes = {
            enabled: function() {
                service.enabled = true;
                $rs.$broadcast('enableDatePicker')
            },
            disabled: function() {
                service.enabeld = false;
                $rs.$broadcast('disableDatePicker')
            }
        };
        //check to ensure that a date range has been loaded after a page refresh
        if (!service.startDate || !service.endDate) {
            service.setDefaultDates();
        }
        modes[(modes.hasOwnProperty(mode) ? mode : 'disabled')]();
    };
    return service;
}]);